import { CacheProvider, ThemeProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { GlobalStyles } from '../GlobalStyles/GlobalStyles'

const swashbuckleCache = createCache({
  key: 'homebot',
  prepend: true,
})

export const SwashbuckleProvider = ({ theme, children }) => (
  <CacheProvider value={swashbuckleCache}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  </CacheProvider>
)
